var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"pb-3"},[_c('div',{staticStyle:{"width":"100%"}},[_c('img',{staticStyle:{"margin-left":"auto","margin-right":"auto","display":"block"},attrs:{"src":"banner-ads.png","alt":""}})])])
}]

export { render, staticRenderFns }